export enum AlertTypeEnum {
  INFO,
  WARNING,
  SUCCESS
}
